export default class CustomMotifInput {
    typeId;
    text1;
    font1;
    color1;
    flossId;
    textAlign;
    imageData;
    fontSize1;
    constructor(text1, font1, color1, flossId, fontSize1) {
        this.text1 = text1;
        this.font1 = font1;
        this.color1 = color1;
        this.flossId = flossId;
        this.fontSize1 = fontSize1;
    }
}
